(() => {
  angular
    .module('gm.common.filters')
    .filter('gmFormatPrice', gmFormatPriceFilter);

  function gmFormatPriceFilter(
    $filter
  ) {
    'ngInject';

    return (price) => {
      if (!price) {
        return '';
      }
      return $filter('gmyFormatCurrency')(price.amount, price.currency);
    };
  }
})();
